export default __webpack_public_path__ + "static/media/logo.0fc5c643.png";